import { RootState } from 'store/root-reducer';
import { ExternalNotifications } from '../types';

export const getExternalNotifications = (state: RootState): ExternalNotifications | null =>
  state.system.externalNotifications.notifications;

export const isLoading = (state: RootState): boolean => state.system.externalNotifications.isLoading;
